<script>
	import { slide } from 'svelte/transition';
	let expanded = $state(false);
</script>

<div class="bg-white py-12 pb-24 sm:py-24">
	<div class="mx-auto max-w-7xl px-4">
		<section
			class="relative mx-auto flex flex-col justify-center overflow-hidden rounded-3xl px-8 py-20 sm:px-12 lg:px-16 lg:py-28"
		>
			<enhanced:img
				alt="Welcome To Tasmania"
				src="$lib/assets/enhanced/aurora.jpg"
				sizes="(min-width: 1280px) 1280px, 100vw"
				class="absolute inset-0 h-full w-full object-cover lg:object-bottom"
				loading="lazy"
			/>
			<div class="absolute inset-0 bg-foreground/0"></div>

			<div class="relative">
				<enhanced:img
					alt="Tassie Tours Logo"
					src="$lib/assets/logo/logo-white.png"
					sizes="(min-width: 1024px) 175px, 125px"
					loading="lazy"
					class="h-16 w-auto lg:h-24"
				/>
				<h2 class="mt-8 font-heading text-3xl font-bold tracking-tight text-background sm:text-4xl">
					Welcome to Tasmania
				</h2>
				<div
					class="mt-6 space-y-4 text-base font-semibold leading-7 text-background/85 lg:space-y-8"
				>
					<p>
						Immerse yourself in the breathtaking beauty of this remarkable state, where pristine
						beaches, majestic mountains, enchanting rainforests, and cascading waterfalls await. Our
						rugged coastline is world-class, and our wildlife is truly unique. Prepare for an
						unforgettable journey that will leave a lasting mark on your heart.
					</p>

					<div class="hidden lg:contents">
						<p class="mt-4">
							Prepare to indulge in award-winning produce as we introduce you to the culinary
							delights that Tasmania is renowned for as we explore the spectacular sights of
							Tasmania. Including, the stunning Bruny Island, the awe-inspiring Cradle Mountain,
							majestic kunanyi (Mt Wellington), iconic Wineglass Bay, the charming town of Strahan,
							the vibrant city of Greater Hobart, historic Port Arthur and so much more. Discover
							Australia's best-kept secret and immerse yourself in the captivating stories that have
							made this island so desirable.
						</p>
						<p class="mt-4">
							As a family-owned and operated business, we take pride in showcasing the best of
							Tasmania and are committed to providing you with exceptional experiences.
						</p>
						<p class="mt-4">
							Whether you're seeking day tours from Hobart or all-inclusive multi-day packages,
							Tassie Tours offers a range of unearthed and exhilarating experiences tailored to your
							preferences. Join us as we unveil the hidden treasures of Tasmania and create memories
							that will last a lifetime.
						</p>
					</div>

					{#if expanded}
						<div transition:slide={{ duration: 400 }} class="lg:hidden">
							<p>
								Prepare to indulge in award-winning produce as we introduce you to the culinary
								delights that Tasmania is renowned for as we explore the spectacular sights of
								Tasmania. Including, the stunning Bruny Island, the awe-inspiring Cradle Mountain,
								majestic kunanyi (Mt Wellington), iconic Wineglass Bay, the charming town of
								Strahan, the vibrant city of Greater Hobart, historic Port Arthur and so much more.
								Discover Australia's best-kept secret and immerse yourself in the captivating
								stories that have made this island so desirable.
							</p>
							<p class="mt-4">
								As a family-owned and operated business, we take pride in showcasing the best of
								Tasmania and are committed to providing you with exceptional experiences.
							</p>
							<p class="mt-4">
								Whether you're seeking day tours from Hobart or all-inclusive multi-day packages,
								Tassie Tours offers a range of unearthed and exhilarating experiences tailored to
								your preferences. Join us as we unveil the hidden treasures of Tasmania and create
								memories that will last a lifetime.
							</p>
						</div>
					{/if}
				</div>

				<button
					onclick={() => (expanded = !expanded)}
					class="mt-6 flex items-center gap-1 text-sm font-semibold text-background/80 underline-offset-2 transition hover:text-background lg:hidden"
				>
					{expanded ? 'Read less' : 'Read more'}
				</button>
			</div>
		</section>
	</div>
</div>
